import { JCMSImage } from '../JCMSImage';
import { JSection } from '../JSection';
import { JSectionsWrapper } from '../JSectionsWrapper';
import { CMSImage, CMSSection } from '../models';
import './style/JResultGame.scss';
import React from "react";


export type ResultRewardProp = {
    images?: CMSImage[],
    title?: string,
    text?: string,
}

export type ResultGameProps = {
    pageConfig?: CMSSection
}

export const JResultGame = ({ pageConfig }: ResultGameProps) => {
    return (
        <JSection>
            <JSectionsWrapper>
                {
                    pageConfig?.image && (
                        <JSection context="reward-image">
                            <JCMSImage image={pageConfig?.image} />
                        </JSection>

                    )
                }
                <JSection {...pageConfig} cta={pageConfig?.cta} renderCTA />
            </JSectionsWrapper>
        </JSection>
    );
};
